(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const bigVideoContainers = document.querySelectorAll('.big-video-container');
    
    if (bigVideoContainers.length === 0) return;

    bigVideoContainers.forEach(function(container) {
      const video = container.querySelector('video');
      const playButton = container.querySelector('.playButton');
      const overlay = container.querySelector('.big-video-overlay');
      const roundButton = container.querySelector('.button.round');

      if (!video || !playButton) return;

      // Function to toggle video play/pause
      const toggleVideo = function(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
        
        // Play/pause current video
        if (video.paused || video.ended) {
          video.play().then(function() {
            container.classList.add('playing');
          }).catch(function(error) {
            console.error('Error playing video:', error);
            // Attempt to load and play again if there's an error
            video.load();
            video.play().then(function() {
              container.classList.add('playing');
            }).catch(function(retryError) {
              console.error('Retry playing video failed:', retryError);
            });
          });
        } else {
          video.pause();
          container.classList.remove('playing');
        }
      };
      
      // Play button click handler
      playButton.addEventListener('click', toggleVideo, true);
      
      // Also handle video element clicks directly
      video.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleVideo(e);
      }, true);
      
      // Also handle clicks on the round button inside
      if (roundButton) {
        roundButton.addEventListener('click', toggleVideo, true);
      }

      // Click on overlay to play/pause
      overlay.addEventListener('click', function(e) {
        // Only trigger if the click is directly on the overlay, not the play button
        if (e.target === overlay || e.target.closest('.big-video-overlay')) {
          toggleVideo(e);
        }
      }, true);

      // Video ended handler
      video.addEventListener('ended', function() {
        container.classList.remove('playing');
        video.currentTime = 0;
      });

      // Video pause handler
      video.addEventListener('pause', function() {
        if (video.currentTime > 0 && !video.ended) {
          container.classList.remove('playing');
        }
      });
    });
  });
})();

